import { useMutation, useQuery } from '@tanstack/react-query';
import { getPrivateAxiosInstance } from '../../../axiosInstances/axiosPrivate';
import { AcademiaResponse } from '../../../types/common';
import {
  AssociateFeedback,
  AssociateFeedbackBody,
} from '../../../types/feedbacks';
import { returnQueryConfig } from '../../../utils/commonFunctions';

const useAssociateFeedbackActions = (
  whichAction: 'associateFeedbackList' | ''
) => {
  // query function to fetch associate feedback list from database declared here
  const getAssociateFeedbackListHandler = useQuery({
    queryKey: ['associate-feedback-list'],
    queryFn: async (): Promise<AcademiaResponse<Array<AssociateFeedback>>> => {
      const response = await getPrivateAxiosInstance('appointment').get(
        '/associate/feedback/list/'
      );

      return response.data;
    },

    ...returnQueryConfig(whichAction === 'associateFeedbackList'),
  });

  // mutation function to create new associate feedback declared
  const createAssociateFeedbackHandler = useMutation({
    mutationFn: async ({
      body,
    }: {
      body: AssociateFeedbackBody;
    }): Promise<AcademiaResponse<AssociateFeedback>> => {
      const response = await getPrivateAxiosInstance('appointment').post(
        '/associate/feedback/create/',
        body
      );

      return response.data;
    },
  });

  return { getAssociateFeedbackListHandler, createAssociateFeedbackHandler };
};

export default useAssociateFeedbackActions;
